import React, { useEffect } from 'react';
import { UnityMessageIncomingEvent } from 'app/common/eventbus/Events';

import { VuplexEvent, VuplexInstance } from './types/Vuplex';

type TProps = {
    vuplexInstance: VuplexInstance;
};

export const VuplexEventNotificationForwarder = (props: React.PropsWithChildren<TProps>) => {
    useEffect(() => {
        if (!props.vuplexInstance) {
            return; // Not running inside a Vuplex webview.
        }

        const onVuplexMessage = (event: VuplexEvent) => {
            UnityMessageIncomingEvent.fire(event?.data);
        };

        props.vuplexInstance.addEventListener('message', onVuplexMessage);

        return () => {
            props.vuplexInstance.removeEventListener('message', onVuplexMessage);
        };
    }, [props.vuplexInstance]);

    return <>{props.children}</>;
};
